/* ===========================================================================
   Cart drawer + quick add
   ---------------------------------------------------------------------------
   Markup: snippets/cart-drawer.liquid (drawer), cart-drawer-quick-add.liquid
   (card buttons), cart-drawer-offer.liquid (offer line). Styles: ddc-drawer.css.

   How it hooks in
   - Every add-to-cart on the site is a real <form action="/cart/add">: the PDP
     form (#pdp-form, also submitted by the sticky bar), the homepage canvas
     bands, and the quick-add buttons on cards. This script catches their
     submit, posts the same fields to /cart/add.js and opens the drawer. With
     scripting off, or if the request never leaves the browser, the form
     posts normally and the shopper lands on the cart page as before.
   - Other scripts that call /cart/add.js themselves (the wishlist page) are
     noticed through a thin fetch wrapper, so the drawer and badge follow.

   Cart attributes (ddc_cid / ddc_ref, affiliate attribution) are never sent
   or touched: only /cart/add.js, /cart/change.js and /cart.js are used, and
   none of those alter attributes. /cart/update.js is deliberately avoided.

   Lines are changed by LINE NUMBER, the same as the cart page (ddc-cart.js).
   ========================================================================= */
(function () {
  "use strict";
  if (window.ddcDrawer) return;

  var root = document.getElementById("CartDrawer");
  var dataEl = document.getElementById("CartDrawerData");
  if (!root || !dataEl || !window.fetch || !window.FormData) return;

  var cfg;
  try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var ROUTE = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var FLAG = "__ddcDrawer"; // marks this script's own requests for the fetch wrapper
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)");

  var panel = root.querySelector(".ddc-drawer__panel");
  var bodyEl = root.querySelector(".ddc-drawer__body");
  var linesEl = root.querySelector("[data-drawer-lines]");
  var emptyEl = root.querySelector("[data-drawer-empty]");
  var footEl = root.querySelector("[data-drawer-foot]");
  var subtotalEl = root.querySelector("[data-drawer-subtotal]");
  var discountsEl = root.querySelector("[data-drawer-discounts]");
  var countEl = root.querySelector("[data-drawer-count]");
  var noticeEl = root.querySelector("[data-drawer-notice]");
  var liveEl = document.querySelector("[data-drawer-live]");

  var state = { cart: cfg.cart || null, open: false, busy: false, opener: null, closeTimer: null };

  /* --- helpers ----------------------------------------------------------- */

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  /* shop.money_format can arrive HTML-encoded ("&#8377;{{amount}}") or wrapped
     in a span; decode and strip once so the output matches Liquid's `money`. */
  var moneyFormat = (function () {
    var t = document.createElement("textarea");
    t.innerHTML = String(cfg.moneyFormat || "₹{{amount}}").replace(/<[^>]*>/g, "");
    return t.value;
  })();

  function money(cents) {
    cents = Number(cents) || 0;
    var m = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    var kind = m ? m[1] : "amount";
    function fmt(dec, thou, point) {
      var parts = (cents / 100).toFixed(dec).split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts[1] ? parts[0] + point + parts[1] : parts[0];
    }
    var v;
    switch (kind) {
      case "amount_no_decimals": v = fmt(0, ",", "."); break;
      case "amount_with_comma_separator": v = fmt(2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": v = fmt(0, ".", ","); break;
      case "amount_with_apostrophe_separator": v = fmt(2, "'", "."); break;
      case "amount_with_space_separator": v = fmt(2, " ", ","); break;
      default: v = fmt(2, ",", ".");
    }
    return m ? moneyFormat.replace(m[0], v) : v;
  }

  function sized(src, w) {
    if (!src) return "";
    return src + (src.indexOf("?") > -1 ? "&" : "?") + "width=" + w;
  }

  function plural(n) { return n + (n === 1 ? " item" : " items"); }

  function api(path, body) {
    var init = { method: body ? "POST" : "GET", credentials: "same-origin", headers: { Accept: "application/json" } };
    init[FLAG] = true;
    if (body instanceof FormData) {
      init.body = body;
    } else if (body) {
      init.headers["Content-Type"] = "application/json";
      init.body = JSON.stringify(body);
    }
    return window.fetch(ROUTE + path, init).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        return { ok: r.ok, status: r.status, data: data || {} };
      });
    });
  }

  var liveTimer;
  function announce(text) {
    if (!liveEl) return;
    /* Clear first so the same sentence twice in a row is still read out. */
    liveEl.textContent = "";
    clearTimeout(liveTimer);
    liveTimer = setTimeout(function () { liveEl.textContent = text; }, 60);
  }

  function say(text) {
    if (!noticeEl) return;
    noticeEl.textContent = text || "";
    noticeEl.hidden = !text;
  }

  /* --- header badge ------------------------------------------------------ */

  /* The canvas header only renders a badge when the cart is non-empty, so the
     first add has to create one, positioned as cv-header-links.liquid does. */
  function syncBadges(count) {
    var links = document.querySelectorAll("a.ddc-hl[href]");
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.getAttribute("href") !== cfg.cartUrl) continue;
      a.setAttribute("aria-label", "Cart, " + count + " items");
      var badge = a.querySelector(".ddc-hl__badge");
      if (!badge && count > 0) {
        var mobile = !!a.closest(".ddc-cv__stage--m");
        badge = document.createElement("span");
        badge.className = "ddc-hl__badge" + (mobile ? " ddc-hl__badge--m" : "");
        badge.setAttribute("style", mobile ? "left:17px;top:6px" : "left:30px;top:4px");
        a.appendChild(badge);
      }
      if (badge) {
        badge.textContent = count;
        badge.hidden = count < 1;
      }
    }
    var counts = document.querySelectorAll("[data-cart-count]");
    for (var j = 0; j < counts.length; j++) counts[j].textContent = count;
  }

  /* --- offer line -------------------------------------------------------- */

  function renderOffer(total) {
    var threshold = Number(cfg.thresholdPaise) || 0;
    var msg, pct = 0, bar = false, reached = false;
    if (threshold > 0) {
      bar = true;
      var remaining = threshold - total;
      if (remaining > 0) {
        msg = String(cfg.goalMessage || "").replace("{amount}", money(remaining));
        pct = Math.max(0, Math.min(100, Math.floor((total * 100) / threshold)));
      } else {
        msg = cfg.reachedMessage || "";
        pct = 100;
        reached = true;
      }
    } else {
      msg = cfg.defaultMessage || "";
    }
    var offers = document.querySelectorAll("[data-drawer-offer]");
    for (var i = 0; i < offers.length; i++) {
      var o = offers[i];
      var text = o.querySelector("[data-offer-text]");
      var track = o.querySelector("[data-offer-track]");
      var fill = o.querySelector("[data-offer-fill]");
      if (text) text.textContent = msg;
      o.hidden = !msg;
      o.classList.toggle("is-reached", reached);
      if (track) {
        track.hidden = !bar;
        track.setAttribute("aria-valuenow", pct);
      }
      if (fill) fill.style.width = pct + "%";
    }
  }

  /* --- drawer rendering -------------------------------------------------- */

  function lineHtml(item, index) {
    var line = index + 1;
    var title = item.product_title || item.title || "";
    var size = item.variant_title && !/^Default Title$/i.test(item.variant_title) ? item.variant_title : "";
    var name = title + (size ? ", " + size : "");
    var url = item.url || "#";
    var props = "";
    if (item.properties) {
      Object.keys(item.properties).forEach(function (k) {
        var v = item.properties[k];
        if (k.charAt(0) === "_" || v == null || v === "") return;
        props += '<p class="ddc-drawer__prop">' + esc(k) + ": " + esc(v) + "</p>";
      });
    }
    var discounts = "";
    (item.line_level_discount_allocations || []).forEach(function (d) {
      var t = d.discount_application && d.discount_application.title;
      discounts += '<p class="ddc-drawer__disc">' + esc(t || "Discount") + " (&minus;" + esc(money(d.amount)) + ")</p>";
    });
    var was = item.original_line_price > item.final_line_price
      ? '<s class="ddc-drawer__was">' + esc(money(item.original_line_price)) + "</s>" : "";

    return '<li class="ddc-drawer__line" data-line="' + line + '" data-key="' + esc(item.key) + '">' +
      '<a class="ddc-drawer__media" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' +
        (item.image ? '<img src="' + esc(sized(item.image, 180)) + '" alt="" width="72" height="72" loading="lazy">' : "") +
      "</a>" +
      '<div class="ddc-drawer__info">' +
        '<a class="ddc-drawer__name" href="' + esc(url) + '">' + esc(title) + "</a>" +
        (size ? '<p class="ddc-drawer__size"><span>' + esc(size) + "</span></p>" : "") +
        props + discounts +
        '<div class="ddc-drawer__row">' +
          '<div class="ddc-drawer__qty" role="group" aria-label="' + esc("Quantity, " + name) + '">' +
            '<button type="button" class="ddc-drawer__step" data-step="-1" data-focus="minus" aria-label="' +
              esc((item.quantity > 1 ? "Decrease quantity of " : "Remove ") + name) + '">&minus;</button>' +
            '<input class="ddc-drawer__num" type="number" min="0" inputmode="numeric" value="' + item.quantity +
              '" data-focus="num" aria-label="' + esc("Quantity for " + name) + '">' +
            '<button type="button" class="ddc-drawer__step" data-step="1" data-focus="plus" aria-label="' +
              esc("Increase quantity of " + name) + '">+</button>' +
          "</div>" +
          '<button type="button" class="ddc-drawer__remove" data-remove data-focus="remove" aria-label="' +
            esc("Remove " + name) + '">Remove</button>' +
        "</div>" +
      "</div>" +
      '<p class="ddc-drawer__price">' + was + "<strong>" + esc(money(item.final_line_price)) + "</strong></p>" +
    "</li>";
  }

  function render(newKey) {
    var cart = state.cart;
    if (!cart) return;
    var items = cart.items || [];
    var count = cart.item_count || 0;

    if (countEl) countEl.innerHTML = count ? count + '<span class="ddc-visually-hidden">' + (count === 1 ? " item" : " items") + "</span>" : "";
    linesEl.innerHTML = items.map(lineHtml).join("");
    emptyEl.hidden = items.length > 0;
    footEl.hidden = items.length === 0;
    subtotalEl.textContent = money(cart.total_price);

    var disc = "";
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      disc += '<p class="ddc-drawer__disc">' + esc(d.title || "Discount") + " (&minus;" +
        esc(money(d.total_allocated_amount)) + ")</p>";
    });
    discountsEl.innerHTML = disc;
    discountsEl.hidden = !disc;

    renderOffer(cart.total_price || 0);

    if (newKey) {
      var li = linesEl.querySelector('[data-key="' + (window.CSS && CSS.escape ? CSS.escape(newKey) : newKey) + '"]');
      if (li) {
        li.classList.add("is-new");
        if (li.scrollIntoView) li.scrollIntoView({ block: "nearest" });
      }
    }
  }

  function setCart(cart, newKey) {
    if (!cart || !cart.items) return;
    state.cart = cart;
    render(newKey);
    syncBadges(cart.item_count || 0);
    document.dispatchEvent(new CustomEvent("ddc:cart", { detail: { cart: cart } }));
  }

  function refresh(newKey) {
    return api("cart.js").then(function (res) {
      if (res.ok) setCart(res.data, newKey);
      return state.cart;
    });
  }

  /* --- open / close, focus trap ------------------------------------------ */

  function focusables() {
    return Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (el) { return !el.closest("[hidden]") && el.getClientRects().length > 0; }
    );
  }

  function onKey(e) {
    if (!state.open) return;
    if (e.key === "Escape" || e.key === "Esc") {
      e.preventDefault();
      close();
      return;
    }
    if (e.key !== "Tab") return;
    var f = focusables();
    if (!f.length) { e.preventDefault(); panel.focus(); return; }
    var first = f[0], last = f[f.length - 1], active = document.activeElement;
    if (e.shiftKey && (active === first || active === panel || !panel.contains(active))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (active === last || !panel.contains(active))) {
      e.preventDefault();
      first.focus();
    }
  }

  function onFocusIn(e) {
    if (state.open && !root.contains(e.target)) panel.focus({ preventScroll: true });
  }

  function open(opener) {
    clearTimeout(state.closeTimer);
    if (state.open) return;
    state.open = true;
    state.opener = opener || document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add("ddc-drawer-lock");
    void panel.offsetWidth; // commit the closed position so the slide-in transitions
    root.classList.add("is-open");
    panel.focus({ preventScroll: true });
    document.addEventListener("keydown", onKey);
    document.addEventListener("focusin", onFocusIn);
  }

  function close() {
    if (!state.open) return;
    state.open = false;
    root.classList.remove("is-open");
    document.documentElement.classList.remove("ddc-drawer-lock");
    document.removeEventListener("keydown", onKey);
    document.removeEventListener("focusin", onFocusIn);
    var instant = reduceMotion && reduceMotion.matches;
    state.closeTimer = setTimeout(function () { if (!state.open) root.hidden = true; }, instant ? 0 : 340);
    say("");
    var back = state.opener;
    if (back && back.closest) {
      var pick = back.closest("details");
      if (pick && !pick.open) back = pick.querySelector("summary");
    }
    if (back && back.isConnected && typeof back.focus === "function") back.focus({ preventScroll: true });
    state.opener = null;
  }

  root.addEventListener("click", function (e) {
    if (e.target.closest("[data-drawer-close]")) { close(); return; }

    var li = e.target.closest(".ddc-drawer__line");
    if (!li) return;
    var line = parseInt(li.getAttribute("data-line"), 10);
    if (e.target.closest("[data-remove]")) { change(line, 0, li, "remove"); return; }
    var step = e.target.closest("[data-step]");
    if (step) {
      var input = li.querySelector(".ddc-drawer__num");
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute("data-step"), 10));
      change(line, next, li, step.getAttribute("data-focus"));
    }
  });

  root.addEventListener("change", function (e) {
    var input = e.target.closest(".ddc-drawer__num");
    if (!input) return;
    var li = input.closest(".ddc-drawer__line");
    var value = parseInt(input.value, 10);
    /* Clearing the box to retype must not delete the line; only an explicit 0
       (or Remove) does. Matches the cart page. */
    if (isNaN(value) || value < 0) { input.value = input.defaultValue; return; }
    change(parseInt(li.getAttribute("data-line"), 10), value, li, "num");
  });

  root.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && e.target.closest(".ddc-drawer__num")) {
      e.preventDefault();
      e.target.blur();
    }
  });

  /* --- line changes ------------------------------------------------------ */

  function setBusy(on) {
    state.busy = on;
    panel.setAttribute("aria-busy", on ? "true" : "false");
  }

  function change(line, quantity, li, focusKey) {
    if (state.busy || !line) return;
    var key = li && li.getAttribute("data-key");
    var item = state.cart && state.cart.items ? state.cart.items[line - 1] : null;
    var name = item ? item.product_title + (item.variant_title && !/^Default Title$/i.test(item.variant_title) ? ", " + item.variant_title : "") : "Item";
    setBusy(true);
    api("cart/change.js", { line: line, quantity: quantity })
      .then(function (res) {
        if (res.status === 422) {
          /* Shopify capped the line at what is in stock and HAS changed the
             cart. Show the truth and say why. */
          say(res.data.description || res.data.message ||
            "We don't have that many in stock right now, so we've added as many as we can.");
          return refresh();
        }
        if (!res.ok || !res.data.items) throw new Error("change failed");
        say("");
        setCart(res.data);
        var c = res.data;
        announce((quantity === 0 ? "Removed " + name + "." : name + ", quantity " + quantity + ".") +
          " Cart has " + plural(c.item_count) + ", subtotal " + money(c.total_price) + ".");
      })
      .catch(function () {
        say("Couldn't update your cart. Please check your connection and try again.");
        render();
      })
      .then(function () {
        setBusy(false);
        restoreFocus(key, focusKey);
      });
  }

  /* Re-rendering replaces the buttons, so put focus back on the same control
     of the same line — or, if the line is gone, somewhere sensible. */
  function restoreFocus(key, focusKey) {
    if (!state.open) return;
    var target = null;
    if (key) {
      var sel = window.CSS && CSS.escape ? CSS.escape(key) : key;
      var li = linesEl.querySelector('[data-key="' + sel + '"]');
      if (li) target = li.querySelector('[data-focus="' + focusKey + '"]') || li.querySelector("[data-remove]");
    }
    if (!target) target = linesEl.querySelector("[data-remove]") || emptyEl.querySelector("a") || panel;
    if (target && target.focus) target.focus({ preventScroll: false });
  }

  /* --- adding ------------------------------------------------------------ */

  var lastSubmitter = null;
  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest('button[type="submit"], button:not([type]), input[type="submit"]');
    lastSubmitter = b || null;
  }, true);

  function isAddForm(form) {
    if (!form || form.nodeName !== "FORM") return false;
    if ((form.getAttribute("method") || "").toLowerCase() !== "post") return false;
    if (form.hasAttribute("data-no-drawer")) return false;
    return /\/cart\/add(\.js)?\/?(\?|#|$)/.test(form.getAttribute("action") || "");
  }

  function nativeSubmit(form, submitter) {
    if (submitter && submitter.name && !form.querySelector('input[type="hidden"][name="' + submitter.name + '"]')) {
      var h = document.createElement("input");
      h.type = "hidden";
      h.name = submitter.name;
      h.value = submitter.value;
      form.appendChild(h);
    }
    HTMLFormElement.prototype.submit.call(form);
  }

  function addFromForm(form, submitter) {
    if (form.__ddcAdding) return;
    var fd = new FormData(form);
    if (submitter && submitter.name) fd.set(submitter.name, submitter.value);
    if (!fd.get("id") && !fd.get("items[0][id]")) { nativeSubmit(form, submitter); return; }

    var pick = form.closest("details[data-qa-pick]");
    var busyEl = pick ? pick.querySelector("summary") : submitter;
    form.__ddcAdding = true;
    if (busyEl) { busyEl.classList.add("is-adding"); busyEl.setAttribute("aria-busy", "true"); }

    function done() {
      form.__ddcAdding = false;
      if (busyEl) { busyEl.classList.remove("is-adding"); busyEl.removeAttribute("aria-busy"); }
    }

    api("cart/add.js", fd)
      .then(function (res) {
        done();
        if (pick) pick.open = false;
        var opener = pick ? pick.querySelector("summary") : submitter || form.querySelector('[type="submit"]');
        if (!res.ok) {
          /* e.g. "All 10 Body Wash are in your cart." Shown in the drawer, next
             to the cart it refers to. */
          return refresh().then(function () {
            say(res.data.description || res.data.message || "Couldn't add that to your cart. Please try again.");
            open(opener);
            announce(noticeEl ? noticeEl.textContent : "");
          });
        }
        var added = res.data.items ? res.data.items[0] : res.data;
        return refresh(added && added.key).then(function (cart) {
          say("");
          if (!cfg.isCartPage) open(opener);
          var size = added && added.variant_title && !/^Default Title$/i.test(added.variant_title) ? ", " + added.variant_title : "";
          announce("Added " + (added ? added.product_title + size : "item") + " to your cart. Cart has " +
            plural(cart ? cart.item_count : 0) + ", subtotal " + money(cart ? cart.total_price : 0) + ".");
          if (cfg.isCartPage) window.location.reload();
        });
      }, function () {
        /* The request never completed (offline, blocked). The plain form post
           is still a working route to the cart. */
        done();
        nativeSubmit(form, submitter);
      });
  }

  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (e.defaultPrevented || !isAddForm(form)) return;
    var submitter = e.submitter || (lastSubmitter && (lastSubmitter.form === form) ? lastSubmitter : null);
    if (submitter && submitter.disabled) return;
    e.preventDefault();
    addFromForm(form, submitter);
  });

  /* --- quick-add size popovers ------------------------------------------- */

  function closePicks(except) {
    var open = document.querySelectorAll("details[data-qa-pick][open]");
    for (var i = 0; i < open.length; i++) if (open[i] !== except) open[i].open = false;
  }

  document.addEventListener("toggle", function (e) {
    var d = e.target;
    if (!d.matches || !d.matches("details[data-qa-pick]") || !d.open) return;
    closePicks(d);
    var first = d.querySelector(".ddc-qa__size:not([disabled])");
    if (first) first.focus({ preventScroll: true });
  }, true);

  document.addEventListener("click", function (e) {
    var inside = e.target.closest && e.target.closest("details[data-qa-pick]");
    closePicks(inside);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape" && e.key !== "Esc") return;
    var d = e.target.closest && e.target.closest("details[data-qa-pick][open]");
    if (!d) return;
    d.open = false;
    var s = d.querySelector("summary");
    if (s) s.focus();
  });

  /* --- the header cart icon opens the drawer ----------------------------- */

  document.addEventListener("click", function (e) {
    if (cfg.isCartPage || e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest("a[href]");
    if (!a || a.getAttribute("href") !== cfg.cartUrl || root.contains(a)) return;
    if (!a.closest(".shopify-section-group-header-group, .ddc-header")) return;
    e.preventDefault();
    say("");
    open(a);
    refresh();
  });

  /* --- other scripts adding to the cart ---------------------------------- */

  var prevFetch = window.fetch;
  window.fetch = function (input, init) {
    var p = prevFetch.apply(this, arguments);
    if (init && init[FLAG]) return p;
    try {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        var isAdd = /\/cart\/add/.test(url);
        p.then(function (r) {
          if (!r.ok) return;
          refresh().then(function () { if (isAdd && !cfg.isCartPage) open(document.activeElement); });
        }, function () {});
      }
    } catch (x) {}
    return p;
  };

  /* Back/forward from checkout restores this page from cache with a stale
     cart; re-read it. */
  window.addEventListener("pageshow", function (e) { if (e.persisted) refresh(); });

  render();

  window.ddcDrawer = { open: open, close: close, refresh: refresh };
})();
